import { SxProps, Theme } from '@mui/material';

export const contentSx: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	height: '100%',
	p: '10px',
};

export const formContainerSx: SxProps<Theme> = {
	flex: 1,
	padding: '10px',
};

export const selectMenuSx: SxProps<Theme> = {
	zIndex: 9999999, // Above DiBot
};
